import { useScript, defineNuxtPlugin } from '#imports'

export default defineNuxtPlugin({
  name: "scripts:init",
  env: { islands: false },
  parallel: true,
  setup() {
    const convert = useScript({"key":"convert","src":"https://cdn-4.convertexperiments.com/v1/js/10007679-10007800.js?environment=production","defer":false}, { ...{"trigger":"server","warmupStrategy":"dns-prefetch"}, use: () => ({ convert: window.convert }) })
    return { provide: { $scripts: { convert } } }
  }
})